// src/App.jsx
import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import AOS from 'aos'
import 'aos/dist/aos.css'

// Standard Imports for essential components
import Navbar from './Components/Common/Navbar'
import CartSidebar from './Components/Home/CartSidebar'
import Footer from './Components/Common/Footer'
import Loader from './Components/Common/Loader'

// Lazy loaded page components
const Hero = React.lazy(() => import('./Components/Home/Hero'))
const Projects = React.lazy(() => import('./Components/Home/Project'))
const Features = React.lazy(() => import('./Components/Home/Features'))
const AcademicDashboard = React.lazy(() => import('./Components/Pages/AcadmicDashboard'))
const StudentDashboard = React.lazy(() => import('./Components/Pages/StudentDashboard'))
const ResetPassword = React.lazy(() => import('./Components/Auth/ResetPassword'))
const Checkout = React.lazy(() => import('./Components/Courses/Checkout'))
const AdminPortal = React.lazy(() => import('./Components/Admin/AdminPortal'))
const PublicRoute = React.lazy(() => import('./Components/Auth/PublicRoute'))
const PrivateRoute = React.lazy(() => import('./Components/Auth/PrivateRoute'))
const ComingSoon = React.lazy(() => import('./Components/Pages/ComingSoon'))

// MAINTENANCE TOGGLE
const MAINTENANCE_MODE = true;

// Dark mode wrapper
const ThemeWrapper = ({ children }) => {
  const darkMode = useSelector((state) => state.theme.darkMode)

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 50,
      delay: 100,
    })
  }, [])

  return (
    <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'dark bg-slate-900 text-slate-100' : 'bg-slate-50 text-slate-900'
      }`}>
      {children}
    </div>
  )
}

function AppContent() {
  const [isInitialLoading, setIsInitialLoading] = React.useState(true);

  useEffect(() => {
    // Simulate a minimum loading time for a smooth brand intro
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (isInitialLoading) {
    return <Loader />;
  }

  // MAINTENANCE MODE OVERRIDE
  if (MAINTENANCE_MODE) {
    return (
      <ThemeWrapper>
        <React.Suspense fallback={<Loader />}>
          <ComingSoon />
        </React.Suspense>
      </ThemeWrapper>
    );
  }

  return (
    <ThemeWrapper>
      <Router>
        <Navbar />
        <CartSidebar />
        <main className="pt-16">
          <React.Suspense fallback={<Loader />}>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Hero />
                    <Projects />
                    <Features />
                  </>
                }
              />
              <Route path="/projects" element={<Projects />} />
              <Route path="/change-password/:token" element={<ResetPassword />} />

              {/* ---------- PUBLIC ROUTES ---------- */}
              <Route element={<PublicRoute />}>
              </Route>

              {/* ---------- PRIVATE ROUTES ---------- */}
              <Route element={<PrivateRoute />}>
                <Route path="/dashboard" element={<StudentDashboard />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/admin-kamlesh" element={<AdminPortal />} />
              </Route>
            </Routes>
          </React.Suspense>
        </main>
        <Footer />
      </Router>
    </ThemeWrapper>
  )
}

function App() {
  return <AppContent />
}

export default App